var _rect, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#FFF1C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9094 41.7975C94.0953 36.5557 103.844 36.5557 111.03 41.7975C114.543 44.3601 118.781 45.7371 123.129 45.7288C132.024 45.7119 139.911 51.4421 142.643 59.9066C143.979 64.0447 146.598 67.6497 150.121 70.1989C157.327 75.4133 160.34 84.685 157.575 93.139C156.223 97.272 156.223 101.728 157.575 105.861C160.34 114.315 157.327 123.587 150.121 128.801C146.598 131.35 143.979 134.955 142.643 139.093C139.911 147.558 132.024 153.288 123.129 153.271C118.781 153.263 114.543 154.64 111.03 157.203C103.844 162.444 94.0953 162.444 86.9094 157.203C83.3964 154.64 79.1584 153.263 74.8101 153.271C65.9155 153.288 58.0285 147.558 55.296 139.093C53.9602 134.955 51.341 131.35 47.8182 128.801C40.6124 123.587 37.5998 114.315 40.3645 105.861C41.7161 101.728 41.7161 97.272 40.3645 93.139C37.5998 84.685 40.6124 75.4133 47.8182 70.1989C51.341 67.6497 53.9602 64.0447 55.296 59.9066C58.0285 51.4421 65.9155 45.7119 74.8101 45.7288C79.1584 45.7371 83.3964 44.3601 86.9094 41.7975Z",
    fill: "#D49347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.619,
    cy: 114.453,
    rx: 22.4822,
    ry: 22.4822,
    fill: "#D69446"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.4822,
    cy: 114.767,
    rx: 22.4822,
    ry: 22.4822,
    fill: "#D69446"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.126,
    cy: 102.114,
    rx: 41.3046,
    ry: 26.1421,
    fill: "#C27E2D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.7212,
    cy: 128.884,
    rx: 47.5787,
    ry: 26.1421,
    fill: "#D49347"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.393,
    cy: 109.536,
    r: 5.27197,
    fill: "#101111"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5454,
    cy: 101.772,
    r: 5.27197,
    fill: "#101111"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.594,
    cy: 101.772,
    r: 5.27197,
    fill: "#101111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog1);
export default __webpack_public_path__ + "static/media/dog1.a51ea885ac7d178c8a913aae16c2126e.svg";
export { ForwardRef as ReactComponent };